import { useDispatch, useSelector } from 'react-redux';
import { WidgetProps } from '@rjsf/core';
import { StateShape as ReduxStateShape } from '../../reducers';
import { actionCreators } from '../../reducers/resources';
import { TextInput } from '../BaseComponents';
import { actionCreators as templateEditorActionCreators } from '../../reducers/templateEditor';

const ResourcePicker = (props: WidgetProps) => {
    const { schema, value, placeholder, onChange, id } = props;
    const { isShowResourcePicker, isShowAnnotationPicker, isShowDataPicker } = useSelector(
        (state: ReduxStateShape) => ({
            ...state.resources,
            ...state.templateEditor,
        })
    );

    const dispatch = useDispatch();

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        onChange(e.target.value);
        isShowResourcePicker && dispatch(actionCreators.setIsShowResourcePicker(false));
        isShowAnnotationPicker! &&
            dispatch(templateEditorActionCreators.setIsShowAnnotationPicker(false));
    };

    const handleResourcePicker = () => {
        !isShowResourcePicker && dispatch(actionCreators.setIsShowResourcePicker(true));
        dispatch(templateEditorActionCreators.setIsShowDataPicker(false));
        dispatch(templateEditorActionCreators.setIsShowAnnotationPicker(false));
    };

    const handleAnnotationPicker = () => {
        !isShowAnnotationPicker! &&
            dispatch(templateEditorActionCreators.setIsShowAnnotationPicker(true));
        dispatch(actionCreators.setIsShowResourcePicker(false));
        dispatch(templateEditorActionCreators.setIsShowDataPicker(false));
    };

    return (
        <div className="resource-picker-container" id={id}>
            <div className="label">
                <label data-testId="label">{schema.title}</label>
                <div className="buttons">
                    <div
                        className="resource"
                        onClick={() => {
                            id && dispatch(actionCreators.setselectedSchemaId(id));
                            handleResourcePicker();
                        }}
                    >
                        {'R'}
                    </div>
                    <div
                        className="annotation"
                        onClick={() => {
                            id && dispatch(actionCreators.setselectedSchemaId(id));
                            handleAnnotationPicker();
                        }}
                    >
                        {'A'}
                    </div>
                    <div
                        className="data-picker-selector"
                        onClick={() => {
                            dispatch(
                                templateEditorActionCreators.setIsShowDataPicker(!isShowDataPicker)
                            );
                            dispatch(templateEditorActionCreators.setIsShowAnnotationPicker(false));
                            dispatch(actionCreators.setIsShowResourcePicker(false));
                        }}
                    >
                        {'D'}
                    </div>
                </div>
            </div>
            <div className="resourcer-picker-input">
                <TextInput
                    className="input-text"
                    value={value}
                    placeholder={placeholder}
                    onChange={handleInputChange}
                />
            </div>
        </div>
    );
};

export default ResourcePicker;
